import {
    makeExecutorOwnerDetailsUrl,
    makeSellerUrl,
    makeServiceRequesterUrl,
    trans,
} from '@frontend/helpers'
import type {CategoryType} from '@shared/types/Categories'
import clsx from 'clsx'
import {
    type ReactNode,
    useState,
} from 'react'
import {Link} from 'react-router-dom'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {RatingStars} from 'swayok-react-mdb-ui-kit/components/Icon/RatingStars'
import type {ServiceRequesterDetailsData} from '../../service_requester_info/ServiceRequesterInfoModuleTypes'
import type {SellerDetailsData} from '../SellerInfoModuleTypes'
import {SellerReviewsListModal} from './SellerReviewsListModal'

interface Props {
    seller: SellerDetailsData | ServiceRequesterDetailsData
    noAvatar?: boolean
    categoryType: CategoryType
    noLinkToProfile?: boolean
    noReviewsModal?: boolean
    className?: string
    ratingBlockClassName?: string
    registrationDateClassName?: string
    Menu?: ReactNode | ReactNode[]
}

// Информация о продавце, исполнителе или заказчике услуг.
export function SellerInfo(props: Props) {

    const {
        seller,
        noAvatar,
        categoryType,
        noLinkToProfile,
        noReviewsModal,
        className,
        ratingBlockClassName = 'mt-3',
        registrationDateClassName = 'mt-2 text-center',
        Menu,
    } = props

    // Видимость окна со списком отзывов.
    const [
        isReviewsModalVisible,
        setIsReviewsModalVisible,
    ] = useState<boolean | null>(null)

    const getSellerUrl = (): string => {
        switch (categoryType) {
            case 'service_requests':
                return makeServiceRequesterUrl(seller.id)
            case 'services':
                return makeExecutorOwnerDetailsUrl(seller.id)
            default:
                return makeSellerUrl(seller.id)
        }
    }

    return (
        <div className={className}>
            <div className="flex-container-row align-items-center justify-content-between">
                <div className="flex-1 flex-container-row align-items-center">
                    {!noAvatar && (
                        <div className="profile-avatar me-3">
                            {seller.name.substring(0, 1) || '?'}
                        </div>
                    )}
                    {noLinkToProfile ? (
                        <span className="fw-500">
                            {seller.name}
                        </span>
                    ) : (
                        <Link
                            to={getSellerUrl()}
                            className="fw-500"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {seller.name}
                        </Link>
                    )}
                </div>
                {Menu}
            </div>
            {seller.rating > 0 && (
                <div
                    className={clsx(
                        'flex-row-between flex-wrap',
                        ratingBlockClassName
                    )}
                >
                    <div className="flex-row-center-vertical">
                        <div className="fw-500">
                            {seller.rating}
                        </div>
                        <RatingStars
                            rating={seller.rating}
                            starSize={20}
                            className="mx-2"
                        />
                    </div>
                    {seller.reviewsCount > 0 && !noReviewsModal ? (
                        <Button
                            color="link"
                            className="link-blue text-nowrap side-nav-link"
                            onClick={() => setIsReviewsModalVisible(true)}
                        >
                            {trans().reviews.reviews_count(seller.reviewsCount)}
                        </Button>
                    ) : (
                        <div className="text-nowrap">
                            {trans().reviews.reviews_count(seller.reviewsCount)}
                        </div>
                    )}
                </div>
            )}
            <div
                className={clsx(
                    'text-muted fs-7',
                    registrationDateClassName
                )}
            >
                {trans().seller.on_service_since(seller.registrationDate)}
            </div>
            {!noReviewsModal && (
                <SellerReviewsListModal
                    seller={seller}
                    show={isReviewsModalVisible}
                    onClose={() => {
                        setIsReviewsModalVisible(false)
                    }}
                />
            )}
        </div>
    )
}
